module.exports = "<svg id=\"30240588-69cc-4f38-83e3-24c9deb56a02\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23.15 49.29\"><title>arrow</title><path d=\"M14.75,4.93,28.38,22h-.1l2.37,2.91-2.34,2.89h.07l-13.64,17a3.08,3.08,0,0,0,.45,4.08,2.91,2.91,0,0,0,4.08-.45l17.4-21.75a2.65,2.65,0,0,0,.63-1.81h0a4.28,4.28,0,0,0-.63-1.81L19.28,1.31A2.92,2.92,0,0,0,15.2.86,3,3,0,0,0,14.75,4.93Z\" transform=\"translate(-14.15 -0.23)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/RightArrow.svg
// module id = yT3g
// module chunks = 1